import { render, staticRenderFns } from "./ProgramControls.vue?vue&type=template&id=c1a7202e"
import script from "./ProgramControls.vue?vue&type=script&lang=ts"
export * from "./ProgramControls.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports